import { apiGet, apiPost } from '@/network/api/apiAdapter'
import type { PaymentChannel } from '@/network/api/payment/type'
import type { BaseRes } from '@/network/api/print/type'

const PREFIX = 'webofficial/ai3d/membership/'

export interface AiMembershipProfileDto {
  tier: string
  tierLabel: string
  expireDate: string | null
  availablePoints: number
  totalPoints: number
  totalUsed: number
  usageRecords: Array<{
    id: string
    time: string
    type: string
    typeLabel: string
    quantity: number
    consumeMethod: string
    consumeAmount: string
  }>
  pointRecords: Array<{
    id: number
    type: number
    sourceType: number
    sourceId?: number
    /** 具体来源名，如「黄金会员」「单买」；兼容旧数据时可能为空 */
    sourceLabel?: string
    amount: number
    availableAfter: number
    description?: string
    createdAt: string
  }>
}

export interface AiPurchaseOrderDto {
  orderId: number
  orderNo: string
  payOrderId: number
  outTradeNo: string
  channel: PaymentChannel
  amount: number
  /** @deprecated 兼容旧响应，请使用 amount（元） */
  amountCents?: number
  displayAmount: string
  title: string
  payUrl?: string
  qrCode?: string
  expireAt?: string
}

export const fetchAiMembershipProfileApi = () => apiGet<BaseRes<AiMembershipProfileDto>>(`${PREFIX}profile`)

export const createAiPurchaseApi = (data: {
  product_type: 'membership' | 'refill' | 'single' | 'storage_expansion'
  product_ref: string
  channel: PaymentChannel
  renew_expansion_id?: number
}) => apiPost<BaseRes<AiPurchaseOrderDto>>(`${PREFIX}purchase`, data)

export const fetchAiPurchaseOrderApi = (orderId: number) =>
  apiGet<BaseRes<{ orderId: number; status: string; isPaid: boolean }>>(`${PREFIX}purchase/${orderId}`)
